module.exports = __webpack_public_path__ + "Icono_Mensajes_Active.png";